function prepareImage(img) {
  return new Promise(resolve => {
    img.crossOrigin = 'anonymous';
    if (img.complete && img.naturalWidth) {
      resolve(img);
      return;
    }
    img.onload = function () {
      resolve(img);
    };
  });
}
function prepareVideo(video) {
  return new Promise(resolve => {
    let playing = false;
    let timeupdate = false;
    function canPlay() {
      video.play();
    }
    const isPlaying = () => {
      playing = true;
      video.removeEventListener('playing', isPlaying, true);
      check();
    };
    const isTimeupdate = () => {
      timeupdate = true;
      video.removeEventListener('timeupdate', isTimeupdate, true);
      check();
    };
    const check = () => {
      if (playing && timeupdate) {
        video.removeEventListener('canplay', canPlay, true);
        resolve(video);
      }
    };
    video.addEventListener('playing', isPlaying, true);
    video.addEventListener('timeupdate', isTimeupdate, true);
    video.addEventListener('canplay', canPlay, true);
    canPlay();
  });
}
export function prepareMedia(source, type) {
  const isImage = type === 'IMG';
  return (isImage ? prepareImage(source) : prepareVideo(source)).then(() => {
    const width = isImage ? source.naturalWidth : source.videoWidth;
    const height = isImage ? source.naturalHeight : source.videoHeight;
    return {
      width,
      height
    };
  });
}
//# sourceMappingURL=media.js.map